export const transformNumberToLocaleString = (value) => {
    // replace all comma (,) with a blank character
    // use en-GB as a language for all browsers
    return value === null || value === void 0 ? void 0 : value.toLocaleString('en-GB').replace(/,/g, ' ');
};
